import { FooterRoute } from 'api/footer';
import ApiRoute from 'utils/apiRoute';

export const footerRoute: FooterRoute = new ApiRoute('/footer', 'GET');
